/*----------------------------------------------------------------------
    Function: fetchModules                                           
----------------------------------------------------------------------*/
async function fetchModules() {
    try {
        return await window.cmsGlobal.fetchJson(window.cmsRoutes.apiListMetaItems, {
            lCheckSession: false,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Cms-Internal-Token': window.cmsInternalToken
            },
            cache: 'no-cache',
            credentials: 'same-origin',
            body: JSON.stringify({ cms_internal: '1' })
        });
    } catch (err) {
        window.cmsGlobal.toastError(`main.js::fetchModules(): ${err.message}`);
    }
}

/*----------------------------------------------------------------------
    Function: fetchReleaseVersion
----------------------------------------------------------------------*/
async function fetchReleaseVersion() {
    try {
        const json = await window.cmsGlobal.fetchJson(`${window.cmsRoutes.api}core/api/endpoints/release-version`, {
            lCheckSession: false,
            method: 'GET',
            headers: {
                'X-Cms-Internal-Token': window.cmsInternalToken
            },
            cache: 'no-cache',
            credentials: 'same-origin'
        });

        if (json && json.ok === true && json.release_version !== undefined && json.release_version !== null) {
            return String(json.release_version);
        }
    } catch (err) {
        window.cmsGlobal.toastError(`main.js::fetchReleaseVersion(): ${err.message}`);
    }
    return null;
}

/*----------------------------------------------------------------------
    Function: fetchUpdateStatus
----------------------------------------------------------------------*/
async function fetchUpdateStatus() {
    try {
        return await window.cmsGlobal.fetchJson(`${window.cmsRoutes.api}core/api/endpoints/check-update`, {
            lCheckSession: false,
            method: 'GET',
            headers: {
                'X-Cms-Internal-Token': window.cmsInternalToken
            },
            cache: 'no-cache',
            credentials: 'same-origin'
        });
    } catch (err) {
        window.cmsGlobal.toastError(`main.js::fetchUpdateStatus(): ${err.message}`);
    }
    return null;
}

/*----------------------------------------------------------------------
    Function: runUpdate
----------------------------------------------------------------------*/
async function runUpdate(options = {}) {
    try {
        const payload = {
            cms_internal: '1',
            force: options.force === true
        };

        return await window.cmsGlobal.fetchJson(`${window.cmsRoutes.api}core/api/endpoints/run-update`, {
            lCheckSession: false,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Cms-Internal-Token': window.cmsInternalToken
            },
            cache: 'no-cache',
            credentials: 'same-origin',
            body: JSON.stringify(payload)
        });
    } catch (err) {
        window.cmsGlobal.toastError(`main.js::runUpdate(): ${err.message}`);
    }
    return null;
}

/*----------------------------------------------------------------------
    Function: setUpdateOverlay
----------------------------------------------------------------------*/
function setUpdateOverlay(active) {
    const existing = document.getElementById('cms-update-overlay');

    if (active) {
        document.body.classList.add('cms-update-running');

        if (!existing) {
            const overlay = document.createElement('div');
            overlay.id = 'cms-update-overlay';
            overlay.innerHTML = `
                <div class="cms-update-overlay-card">
                    <div class="cms-update-spinner" aria-hidden="true"></div>
                    <div class="cms-update-overlay-title">Update in progress</div>
                    <div class="cms-update-overlay-text">Please wait, the backend is updating.</div>
                </div>
            `;
            document.body.appendChild(overlay);
        }

        window.onbeforeunload = () => 'Update in progress. Are you sure you want to leave?';
        return;
    }

    document.body.classList.remove('cms-update-running');
    if (existing) {
        existing.remove();
    }
    window.onbeforeunload = null;
}

/*----------------------------------------------------------------------
    Function: buildSidebar                                           
----------------------------------------------------------------------*/
function buildSidebar(modules) {
    const sidebar = document.getElementById('cms-sidebar');
    if (!sidebar) return;
    const originalDisplay = sidebar.style.display;
    const originalVisibility = sidebar.style.visibility;
    const originalTransition = sidebar.style.transition;
    const originalBackground = sidebar.style.backgroundColor;
    sidebar.style.visibility = 'visible';
    sidebar.style.transition = 'none';
    sidebar.style.backgroundColor = '#111b3a';
    sidebar.textContent = '';
    const fragment = document.createDocumentFragment();

    // Add branding block (logo + version) at top
    const branding = document.createElement('div');
    branding.className = 'sidebar-branding';

    const logo = document.createElement('img');
    logo.className = 'sidebar-logo';
    logo.src = '/cmsApp/public/images/ncms_logo.webp';
    logo.alt = 'CMS Logo';
    branding.appendChild(logo);

    const versionLabel = document.createElement('div');
    versionLabel.className = 'sidebar-version';
    versionLabel.textContent = 'Version: —';
    branding.appendChild(versionLabel);

    const updateWrap = document.createElement('div');
    updateWrap.className = 'sidebar-update';

    const updateText = document.createElement('div');
    updateText.className = 'sidebar-update-text';
    updateText.textContent = 'Checking updates...';
    updateWrap.appendChild(updateText);

    const updateButton = document.createElement('button');
    updateButton.type = 'button';
    updateButton.className = 'sidebar-update-btn';
    updateButton.textContent = 'Update';
    updateButton.style.display = 'none';
    updateWrap.appendChild(updateButton);

    branding.appendChild(updateWrap);

    fragment.appendChild(branding);
    const grouped = {};
    const ungrouped = [];

    const logoutLink = document.createElement('a');
    logoutLink.href = '/cmsApp/module/Login/logout';
    logoutLink.className = 'menu-item';
    logoutLink.innerHTML = `<i class="fa-solid fa-right-from-bracket"></i><span>Logout</span>`;

    fetchReleaseVersion().then((releaseVersion) => {
        if (!versionLabel) return;
        if (releaseVersion && releaseVersion.trim()) {
            versionLabel.textContent = `Version: ${releaseVersion}`;
        } else {
            versionLabel.textContent = 'Version: unknown';
        }
    });

    fetchUpdateStatus().then((status) => {
        if (!status || status.ok !== true) {
            updateText.textContent = 'Update check failed';
            return;
        }

        if (status.update_available) {
            const latest = status.latest_version ? ` ${status.latest_version}` : '';
            updateText.textContent = `New version available:${latest}`;
            updateButton.style.display = 'inline-flex';
            updateButton.disabled = false;
        } else {
            updateText.textContent = 'Up to date';
            updateButton.style.display = 'none';
        }
    });

    updateButton.addEventListener('click', async () => {
        updateButton.disabled = true;
        updateButton.textContent = 'Updating...';
        updateText.textContent = 'Update in progress...';
        setUpdateOverlay(true);

        const result = await runUpdate();
        if (!result || result.ok !== true) {
            const err = result && result.error ? result.error : 'Update failed';
            updateText.textContent = err;
            updateButton.disabled = false;
            updateButton.textContent = 'Update';
            setUpdateOverlay(false);
            return;
        }

        if (result.status === 'up_to_date') {
            updateText.textContent = 'Already up to date';
        } else {
            const applied = result.applied_version || result.latest_version || '';
            updateText.textContent = applied ? `Updated to ${applied}` : 'Update complete';
        }

        updateButton.style.display = 'none';
        setUpdateOverlay(false);

        const refreshed = await fetchReleaseVersion();
        if (refreshed && refreshed.trim()) {
            versionLabel.textContent = `Version: ${refreshed}`;
        }
    });

    // Optional: insert at end of sidebar
    fragment.appendChild(logoutLink);

    modules.forEach((mod) => {
        if (!mod.menu) return; // skips this iteration

        if (mod.group) {
            if (!grouped[mod.group]) grouped[mod.group] = [];
            grouped[mod.group].push(mod);
        } else {
            ungrouped.push(mod);
        }
    });

    const currentPath = decodeURIComponent(window.location.pathname);

    // Render ungrouped modules
    ungrouped.forEach((mod) => {
        if (!mod.menu) return; // skips this iteration

        const item = document.createElement('a');
        item.className = 'menu-item';
        item.dataset.module = mod.route;
        item.href = `/cmsApp/module/${mod.route}`;
        item.innerHTML = mod.icon ? `${mod.icon} <span>${mod.title}</span>` : `<span>${mod.title}</span>`;

        if (currentPath.includes(`/module/${mod.route}`)) {
            item.classList.add('active');
        }

        fragment.appendChild(item);
    });

    // Render grouped modules
    Object.entries(grouped).forEach(([groupName, groupModules]) => {
        const groupWrapper = document.createElement('div');
        groupWrapper.className = 'menu-group';

        const groupToggle = document.createElement('div');
        groupToggle.className = 'menu-group-toggle';
        groupToggle.innerHTML = `<span class="link">${groupName}</span><i class="fa fa-chevron-down"></i>`;
        groupToggle.addEventListener('click', () => {
            groupWrapper.classList.toggle('expanded');
        });

        const groupContent = document.createElement('div');
        groupContent.className = 'menu-group-content';
        groupModules.forEach((mod) => {
            const item = document.createElement('a');
            item.className = 'menu-item';
            item.dataset.module = mod.route;
            item.href = `/cmsApp/module/${mod.route}`;
            item.innerHTML = mod.icon ? `${mod.icon} <span>${mod.title}</span>` : `<span>${mod.title}</span>`;

            if (currentPath.includes(`/module/${mod.route}`)) {
                item.classList.add('active');
                groupWrapper.classList.add('expanded', 'has-active');
            }

            groupContent.appendChild(item);
        });

        groupWrapper.appendChild(groupToggle);
        groupWrapper.appendChild(groupContent);
        fragment.appendChild(groupWrapper);
    });

    const revealSidebar = () => {
        sidebar.replaceChildren(fragment);
        sidebar.style.display = originalDisplay;
        sidebar.style.visibility = originalVisibility || 'visible';
        sidebar.style.transition = originalTransition;
        sidebar.style.backgroundColor = originalBackground;
    };

    const waitForWindowLoad = () =>
        new Promise((resolve) => {
            if (document.readyState === 'complete') {
                resolve();
                return;
            }
            window.addEventListener('load', () => resolve(), { once: true });
        });

    const waitForFonts = () => {
        if (document.fonts && typeof document.fonts.ready?.then === 'function') {
            return document.fonts.ready.catch(() => { });
        }
        return Promise.resolve();
    };

    Promise.all([waitForWindowLoad(), waitForFonts()]).then(() => {
        window.setTimeout(() => {
            requestAnimationFrame(() => {
                requestAnimationFrame(revealSidebar);
            });
        }, 120);
    });
}

/*----------------------------------------------------------------------
    Function: getCurrentModuleName
----------------------------------------------------------------------*/
function getCurrentModuleName() {
    const path = decodeURIComponent(window.location.pathname);
    const parts = path.split('/');
    const moduleIndex = parts.indexOf('module');
    if (moduleIndex !== -1 && parts.length > moduleIndex + 1) {
        return parts[moduleIndex + 1];
    }
    return null;
}

/*----------------------------------------------------------------------
    Function: initModuleAssets
----------------------------------------------------------------------*/
async function initModuleAssets(jSonMeta) {
    const moduleName = getCurrentModuleName();
    if (moduleName && window.__cmsSystem) {
        await window.__cmsSystem.load();
        await window.__cmsSystem.init(jSonMeta);
    }
}

/*----------------------------------------------------------------------
    Function: setupFormAnimationUnlock
----------------------------------------------------------------------*/
function setupFormAnimationUnlock() {
    const root = document.documentElement;
    const enableFormAnimations = (event) => {
        if (event?.isTrusted === false) return;
        root.classList.add('cms-forms-interactive');
        ['pointerdown', 'keydown', 'input', 'change', 'submit'].forEach((type) => {
            document.removeEventListener(type, enableFormAnimations, true);
        });
    };

    ['pointerdown', 'keydown', 'input', 'change', 'submit'].forEach((type) => {
        document.addEventListener(type, enableFormAnimations, true);
    });
}

/*----------------------------------------------------------------------
    Function: initCMS
----------------------------------------------------------------------*/
async function findRouteMatch(jSon, routeToFind) {
    return jSon.find((r) => r.route === routeToFind) || null;
}

/*----------------------------------------------------------------------
    Function: issueIntentTokens                                           
----------------------------------------------------------------------*/
async function issueIntentTokens(currentModule) {
    try {
        const payload = {
            cms_internal: '1',
            current_module: currentModule
        };

        const json = await window.cmsGlobal.fetchJson(window.cmsRoutes.apiIssueIntentTokens, {
            lCheckSession: false,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Cms-Internal-Token': window.cmsInternalToken
            },
            cache: 'no-cache',
            credentials: 'same-origin',
            body: JSON.stringify(payload)
        });
        if (!json.success) throw new Error(json.error);
        mergeCmsIntents(json.tokens);
    } catch (err) {
        window.cmsGlobal.toastError(`issueIntentTokens(): ${err.message}`);
    }
}

/*----------------------------------------------------------------------
    Function: mergeCmsIntents                                           
----------------------------------------------------------------------*/
function mergeCmsIntents(intents) {
    if (!intents || typeof intents !== 'object') return;
    window.cmsIntents = window.cmsIntents || {};
    Object.assign(window.cmsIntents, intents);
}

/*----------------------------------------------------------------------
    Function: initCMS
----------------------------------------------------------------------*/
async function initCMS() {
    setupFormAnimationUnlock();

    try {
        // path = cmsApp/module/Dashboard 
        const path = decodeURIComponent(window.location.pathname);

        // parts = [ "", "cmsApp", "module", "Dashboard" ]
        const parts = path.split('/');

        // moduleIndex =  2
        const moduleIndex = parts.indexOf('module');

        // currentModule = Dashboard
        const currentModule = moduleIndex !== -1 && parts.length > moduleIndex + 1 ? parts[moduleIndex + 1] : null;

        if (!currentModule) {
            window.location.href = `${window.cmsRoutes.routeModule}Login`;
        } else {
            const modules = await fetchModules();

            if (modules.success !== undefined && modules.success === false) throw new Error(modules.error);

            if (currentModule !== 'Login') {

                await issueIntentTokens(currentModule);
                buildSidebar(modules);
            }

            const module = await findRouteMatch(modules, currentModule);
            await initModuleAssets(module);
        }
    } catch (err) {
        const container = document.getElementById('cms-main');
        if (container) {
            container.innerHTML = `<p class="error">Failed to initialize CMS. ${err}</p>`;
        }
    }
}

document.addEventListener('DOMContentLoaded', initCMS);
